export const POST_Deposit_START = 'POST_Deposit_START'
export const POST_Deposit_SUCCESS = 'POST_Deposit_SUCCESS'
export const POST_Deposit_FAIL = 'POST_Deposit_FAIL'
export const GET_DepositS_START = 'GET_DepositS_START'
export const GET_DepositS_SUCCESS = 'GET_DepositS_SUCCESS'
